import { useState } from 'react';
import ContentMediaViewer from '../contentMedia/ContentMediaViewer';
import { getContentGalleryItems } from '../../utils/contentMediaUtils';

export const useArticleMediaViewer = () => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [startIndex, setStartIndex] = useState(0);

  const openArticleMedia = (item, index = 0) => {
    const gallery = getContentGalleryItems(item);
    if (!gallery.length) {
      return;
    }
    setItems(gallery);
    setStartIndex(index);
    setOpen(true);
  };

  const mediaViewer = (
    <ContentMediaViewer
      open={open}
      onClose={() => setOpen(false)}
      items={items}
      startIndex={startIndex}
    />
  );

  return { openArticleMedia, mediaViewer };
};
